<template>
  <div class="container">
    <img src="@/assets/logo_blue.png" class="logo" />
    <div class="form" v-if="!resetRequired">
      <Form @submit="onSubmit" :validation-schema="validationSchema">
        <FormError :errors="globalErrors" />
        <Field name="username" v-slot="{ field }">
          <input class="uk-input" type="text" placeholder="ユーザーID" v-bind="field" />
        </Field>
        <FieldError name="username" />
        <Field name="password" v-slot="{ field }">
          <input class="uk-input" :type="inputLock ? 'password' : 'text'" placeholder="パスワード" v-bind="field" />
          <span class="input-icon" :uk-icon="inputLock ? 'icon: lock' : 'icon: unlock'" @click="inputLock = !inputLock"></span>
        </Field>
        <FieldError name="password" />
        <ActionButton title="Login" type="submit" color="primary" :disabled="processing" />
        <div class="forgot-password">
          <router-link :to="`/forgot_password`">
            パスワードを忘れた方はこちら
          </router-link>
        </div>
      </Form>
    </div>
    <div class="form" v-else>
      <ChangePassword @submitted="onPasswordChanged" :values="resetPasswordParams" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.container {
  display: flex;
  height: 100vh !important;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
}
.form {
  width: 400px;
  form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.uk-heading-small {
  color: $brand-color;
  font-weight: bold;
  margin-bottom: $spacing-medium;
}
.uk-input {
  margin: $spacing-ex-small 0;
  border: 0;
  border-bottom: 2px solid $brand-pale-color;
  &::placeholder {
    color: $brand-color;
  }
  &:focus {
    border-bottom-color: $brand-deep-color;
  }
}
.uk-button {
  border-radius: 5px;
  margin-top: $spacing-ex-medium;
  text-transform: none;
  width: 185px;
  color: #fff;
  background-color: $brand-color;
  &:hover,
  &:focus {
    background-color: $brand-deep-color;
    color: $link-color-active;
  }
}
.forgot-password {
  text-decoration: underline;
  margin-top: $spacing-ex-medium;
}
.input-icon {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -20px;
  top: -25px;
  right: -180px;
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Field, Form } from "vee-validate";
import * as yup from "yup";
import Store from "../../store";
import Router from "../../router";
import { AuthApi } from "../../autogen";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ChangePassword from "../organisms/ChangePassword.vue";
import ActionButton from "../atoms/ActionButton.vue";

@Options({
  components: { Form, Field, FieldError, FormError, ChangePassword, ActionButton }
})
export default class Login extends Vue {
  globalErrors: { message: string }[] = [];
  resetPasswordParams = {};
  resetRequired = false;
  processing = false;
  inputLock = true;
  timerId = 0;
  async onSubmit(loginRequest: { username: string; password: string }) {
    this.processing = true;
    try {
      this.timerId = setInterval(() => {
        clearInterval(this.timerId);
        this.globalErrors = [{ message: "サーバーと通信出来ません。暫く経ってから再度お試しください。" }];
        this.processing = false;
      }, 10000);
      const storeInstance = Store.getInstance();
      const auth = await new AuthApi().login(loginRequest).then(auth => {
        storeInstance.setAuth(auth.data);
        return auth.data;
      });
      Router.push(`/clients/${auth.clientId}/departments/all/dashboard`);
    } catch (err) {
      if (err.response.status === 404 && err.response.data.error === "PasswordChangeRequired") {
        this.resetPasswordParams = {
          username: loginRequest.username,
          oldpassword: loginRequest.password
        };
        this.resetRequired = true;
      } else if (err.response.status === 404 && err.response.data.error === "Unauthorized") {
        this.globalErrors = [{ message: err.response.data.message }];
      } else if (err.response.status === 404 && err.response.data.error === "Locked") {
        this.globalErrors = [{ message: err.response.data.message }, { message: "暫く経ってから再度お試しください" }];
      } else {
        this.globalErrors = [{ message: err.response.data.message ? err.response.data.message : err.message }];
      }
    }
    clearInterval(this.timerId);
    this.processing = false;
  }
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      username: yup.string().required(this.$t("input_required", { field: "ユーザーID" })),
      password: yup.string().required(this.$t("input_required", { field: "パスワード" }))
    });
  }
  async onPasswordChanged(values: { username: string; password: string }) {
    const auth = await new AuthApi().login(values);
    Store.getInstance().setAuth(auth.data);
    Router.push(`/clients/${auth.data.clientId}/departments/all/dashboard`);
  }
}
</script>
